<template>
    <div>
        <h2 class="mb-1">{{ $t("settings.users.channels.title") }}</h2>

        <b-form-group>
            <b-form-checkbox
                v-model="allSelected"
                :disabled="userData && userData.id && !userData.auth0Id"
                :indeterminate="indeterminate"
                @change="toggleAll"
            >
                {{
                    allSelected ? $t("settings.users.channels.deselect-all") : $t("settings.users.channels.select-all")
                }}
            </b-form-checkbox>
            <b-form-checkbox-group
                id="channels"
                v-model="userData.channels"
                :disabled="userData && userData.id && !userData.auth0Id"
                :options="channels"
                class="ml-4"
                name="channels"
                stacked
            ></b-form-checkbox-group>
        </b-form-group>

        <hr />
    </div>
</template>
<script>
import { BFormGroup, BFormCheckboxGroup, BFormCheckbox } from "bootstrap-vue";

export default {
    components: {
        BFormGroup,
        BFormCheckbox,
        BFormCheckboxGroup,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },
        channels: {
            type: Array,
            required: true,
        },
    },
    watch: {
        "userData.channels"(newValue, oldValue) {
            if (newValue.length === 0) {
                this.indeterminate = false;
                this.allSelected = false;
            } else if (newValue.length === this.channels.length) {
                this.indeterminate = false;
                this.allSelected = true;
            } else {
                this.indeterminate = true;
                this.allSelected = false;
            }
        },
    },
    methods: {
        toggleAll(checked) {
            this.userData.channels = checked ? this.channels.map((channel) => channel.value) : [];
        },
    },
    setup(props) {
        const allSelected =
            props.channels &&
            props.userData.channels &&
            props.channels.length > 0 &&
            props.channels.length === props.userData.channels.length;
        const indeterminate =
            props.channels &&
            props.userData.channels &&
            props.userData.channels.length > 0 &&
            props.channels.length > props.userData.channels.length;

        return {
            allSelected,
            indeterminate,
        };
    },
};
</script>
